import { useState, useEffect } from 'react';

export default function useAttachement() {
    const [error, setError] = useState();
    const [urls, setUrls] = useState([]);
    const [loading, setLoading] = useState(false);
    const fileUpload = async(file) => {
        var data = new FormData();
        data.append('file', file);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/attachments/upload`, {
                    method: 'POST',
                    body: data,
                }
            );

            const result = await response.json();
            if (!response.ok) {
                throw new Error(result);
            }

            return result.url;
        } catch (error) {
            throw error;
        }
    };
    const upload = async(files) => {
        setLoading(true);
        try {
            const _urls = await Promise.all(files.map((file) => fileUpload(file)));

            setUrls(_urls);
            return _urls;
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };
    // useEffect(() => {
    //     if (initial) {
    //         call();
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, []);
    return { urls, error, loading, upload };
}